<div class="quantity-input-wrapper">
  <input
    #quantityInput
    type="number"
    class="form-control quantity-input-no-arrows"
    [class]="extraClass"
    [readonly]="renderStatic"
    [id]="inputId"
    [name]="inputId"
    [required]="required"
    [disabled]="disabled"
    [ngModelOptions]="{ updateOn: 'blur' }"
    [max]="maxValue"
    [min]="minValue"
    [step]="stepAmount"
    [(ngModel)]="value"
    (keydown)="onKeydown($event)"
    (focus)="onInputFocus($event)"
  />
  <div class="quantity-buttons" *ngIf="!renderStatic && !disabled">
    <button
      type="button"
      class="quantity-btn quantity-btn-up"
      (mousedown)="$event.preventDefault()"
      (click)="incrementValue()"
      [disabled]="disabled"
      tabindex="-1"
    >
      <i class="fa fa-chevron-up"></i>
    </button>
    <button
      type="button"
      class="quantity-btn quantity-btn-down"
      (mousedown)="$event.preventDefault()"
      (click)="decrementValue()"
      [disabled]="disabled"
      tabindex="-1"
    >
      <i class="fa fa-chevron-down"></i>
    </button>
  </div>
</div>
